import PageHero from "@/components/PageHero";
import { FadeIn } from "@/components/FadeIn";

export default function LegalPage({ crumb, line1, line2, updated, sections, testid }) {
  return (
    <main data-testid={testid} className="bg-[#f7f2e8]">
      <PageHero crumb={crumb} line1={line1} line2={line2} subtitle={`Last updated: ${updated}`} />
      <section className="max-w-[900px] mx-auto px-5 md:px-10 py-16 md:py-20">
        {sections.map((s, i) => (
          <FadeIn key={s.title} delay={Math.min(i * 0.04, 0.2)} className="mb-10">
            <h2 className="font-serif-display text-2xl md:text-3xl text-[#141414]">
              <span className="font-numeric text-[0.8em] text-[#c9a14a] mr-3">{String(i + 1).padStart(2, "0")}</span>
              {s.title}
            </h2>
            {s.body.map((p) => (
              <p key={p.slice(0, 40)} className="mt-4 text-[14px] text-[#4a4a4a] leading-relaxed">
                {p}
              </p>
            ))}
            {s.list && (
              <ul className="mt-4 space-y-2 list-disc pl-6">
                {s.list.map((l) => (
                  <li key={l} className="text-[14px] text-[#4a4a4a] leading-relaxed">{l}</li>
                ))}
              </ul>
            )}
          </FadeIn>
        ))}
        <FadeIn className="mt-4 border-t border-[#c9a14a]/25 pt-8">
          <p className="text-[13px] text-[#4a4a4a]">
            Questions? Write to us at{" "}
            <a href="mailto:info@carltonwellnesscenter.com" className="text-[#a8813a] underline underline-offset-4">
              info@carltonwellnesscenter.com
            </a>
            .
          </p>
        </FadeIn>
      </section>
    </main>
  );
}
